import { Box, Step } from "@bsm/component";
import { useParams } from "react-router-dom";
import { useStudentDetailsQuery } from "../../../../../hooks/useStudentDetailsQuery";
import { useStudentDetailsParamsSteps } from "../hooks/useStudentDetailsParamsSteps";

export function StudentDetailsParamsContainer() {
    const { id } = useParams();
    const { data, invalidateQuery } = useStudentDetailsQuery(parseInt(id), true);
    const steps = useStudentDetailsParamsSteps();

    return (
        <Box title="Parameters">
            <Step
                defaultValue={[
                    { id: data.user.id },
                    {
                        id: data.parents.find((parent) =>
                            ["DAD", "STEP-DAD"].includes(parent.parentType)
                        )?.user.id,
                    },
                    {
                        id: data.parents.find((parent) =>
                            ["MOM", "STEP-MOM"].includes(parent.parentType)
                        )?.user.id,
                    },
                    {
                        id: data.parents.find(
                            (parent) => parent.parentType === "ASSISTANT"
                        )?.user.id,
                    },
                    // { id: data.parents[3]?.user.id },
                ]}
                steps={steps}
                layout="MENU"
                onStepSubmited={() => invalidateQuery()}
            />
        </Box>
    );
}
